import { CounterpartyHedgedNotionalsData } from '@/models/Counterparty/HedgedNotionals';

import { createAsyncAction } from 'typesafe-actions';

export type SetClosestTradeValuationDateRequestPayload = {
  date: string;
};
export type SetClosestTradeValuationDateSuccessPayload = {
  date: string;
};

export const setClosestTradeValuationDate = createAsyncAction(
  'dashboard/setClosestTradeValuationDate/request',
  'dashboard/setClosestTradeValuationDate/success',
  'dashboard/setClosestTradeValuationDate/failure',
)<
  SetClosestTradeValuationDateRequestPayload,
  SetClosestTradeValuationDateSuccessPayload,
  undefined
>();

export type SetTotalValuePortfolioRequestPayload = {
  date: string;
  currencyId: number;
};
export type SetTotalValuePortfolioSuccessPayload = {
  data: {
    totalPortfolioMtM: number;
    totalPortfolioMtMDate: string;
  };
};

export const setTotalValuePortfolio = createAsyncAction(
  'dashboard/setTotalValuePortfolio/request',
  'dashboard/setTotalValuePortfolio/success',
  'dashboard/setTotalValuePortfolio/failure',
)<
  SetTotalValuePortfolioRequestPayload,
  SetTotalValuePortfolioSuccessPayload,
  undefined
>();

export type CounterPartryNotionalRequestPayload = {
  currencyId: number;
  valueDate: string;
  /** Entity ids the user can see — from `companyEntity.entityList`. */
  visibleEntities: string[];
};

export type CounterPartyNotionalSuccessPayload = {
  data: CounterpartyHedgedNotionalsData;
};

export const setCounterPartyHedgedNotionals = createAsyncAction(
  'dashboard/getCounterPartyHedgedNotionals/request',
  'dashboard/getCounterPartyHedgedNotionals/success',
  'dashboard/getCounterPartyHedgedNotionals/failure',
)<
  CounterPartryNotionalRequestPayload,
  CounterPartyNotionalSuccessPayload,
  undefined
>();

export type CounterPartryExposureRequestPayload = {
  currencyId: number;
};

export type CounterPartyExposureSuccessPayload = {
  data: {
    counterparty_data: [];
    value_date: string;
    value_total: number;
  };
};

export const setCounterPartyExposure = createAsyncAction(
  'dashboard/getCounterPartyExposure/request',
  'dashboard/getCounterPartyExposure/success',
  'dashboard/getCounterPartyExposure/failure',
)<
  CounterPartryExposureRequestPayload,
  CounterPartyExposureSuccessPayload,
  undefined
>();

export type DebtAndHedgeRequestPayload = {
  currencyId: number;
};

export type DebtAndHedgeSuccessPayload = {
  data: {
    debt_data: object;
    debt_data_date: string;
    debt_metrics: object;
    wAvgLifeOfDebt: number;
    wAvgLifeOfHedge: number;
  };
};

export const setDebtAndHedge = createAsyncAction(
  'dashboard/getDebtAndHedge/request',
  'dashboard/getDebtAndHedge/success',
  'dashboard/getDebtAndHedge/failure',
)<DebtAndHedgeRequestPayload, DebtAndHedgeSuccessPayload, undefined>();

export type HedgeNotionalRequestPayload = {
  currencyId: number;
};

export type HedgeTotalSuccessPayload = {
  data: {
    notional_data: [];
    notional_metrics: object;
    notional_data_date: string;
  };
};

export const setHedgeNotional = createAsyncAction(
  'dashboard/setHedgeTotal/request',
  'dashboard/setHedgeTotal/success',
  'dashboard/setHedgeTotal/failure',
)<HedgeNotionalRequestPayload, HedgeTotalSuccessPayload, undefined>();

export type SetTotalPortfolioValueAndSparkDataPayload = {
  currency_id: number;
  date: string;
  visible_entities: string[] | null;
};

export type SparkData = {
  date: string;
  value: string;
};

export type SetTotalPortfolioValueAndSparkDataResponse = {
  spark_data: SparkData[];
  current_value: number | null;
  current_date: string | null;
  previous_value: number | null;
  previous_date: string | null;
  change_amount: number | null;
  change_percentage: number | null;
};

export const setTotalPortfolioValueAndSparkData = createAsyncAction(
  'dashboard/setTotalPortfolioValueAndSparkData/request',
  'dashboard/setTotalPortfolioValueAndSparkData/success',
  'dashboard/setTotalPortfolioValueAndSparkData/failure',
)<
  SetTotalPortfolioValueAndSparkDataPayload,
  SetTotalPortfolioValueAndSparkDataResponse,
  undefined
>();
